import './OrderWizard.scss';

import { Link } from 'react-router';

import { FormPanel } from '@components/FormPanel/FormPanel';
import { ROUTES } from '@constants/routes';

import { useOrderContext } from './hooks/useOrderContext';

export function OrderNotEligible() {
  const { partner } = useOrderContext();

  const checkEligibilityUrl = partner
    ? `/${ROUTES.PARTNERSHIP}/${partner}/${ROUTES.ORDER_CHECK}`
    : `${ROUTES.ORDER}/${ROUTES.ORDER_CHECK}`;

  return (
    <div className='wizard-page'>
      <FormPanel maxWidth='md' layout='sectioned'>
        <FormPanel.Header title="We couldn't verify your eligibility" />
        <FormPanel.Body>
          <p className='form-panel__page-subtitle mt-1'>
            There was a problem verifying your eligibility for this program.
          </p>
          <p className='form-panel__page-subtitle'>
            If you think this is an error, please try again. The details you entered on the previous screen must match
            what&apos;s on file with the program partner.
          </p>
          <p className='form-panel__page-subtitle'>If you already have a MyOme account, please sign in to continue.</p>
          <div className='content-block notice'>
            <p>
              If you&apos;re still experiencing issues, contact us at{' '}
              <a href='mailto:support@myome.com'>support@myome.com</a>
            </p>
          </div>
        </FormPanel.Body>
        <FormPanel.Footer variant='actions-split'>
          <Link to={ROUTES.LOGIN} className='secondary button'>
            Sign in
          </Link>
          <Link to={checkEligibilityUrl} className='primary button'>
            Try again
          </Link>
        </FormPanel.Footer>
      </FormPanel>
    </div>
  );
}
